import * as React from 'react';
import { AutocompleteInput, Edit, EditProps, NumberInput, ReferenceInput, SimpleForm, TextInput } from 'react-admin';
import { UploadImage } from '../components/UploadImage';

export const ProductEdit = (props: EditProps): React.ReactElement => {
	return (
		<Edit {...props} undoable={false}>
			<SimpleForm>
				<NumberInput step={1} source="id" label="#" disabled/>
				<UploadImage step={1} source="featuredImageUrl" label="FEATURED_IMAGE"/>
				<TextInput step={1} source="name" label="NAME"/>
				{/*<NumberInput step={1} source="price" label="PRICE"/>*/}
				<TextInput multiline step={1} source="description" label="DESCRIPTION"/>
				<ReferenceInput
					step={1}
					label="CATEGORY"
					source="categoryId" reference="product-categories"
					alwaysOn
				>
					<AutocompleteInput optionText="name"/>
				</ReferenceInput>

				<TextInput step={1} source="link" label="LINK"/>
				{/*<TextInput type="url" step={1} source="videoUrl" label="VIDEO_LINK"/>*/}
			</SimpleForm>
		</Edit>
	);
};
